import React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import theme from "./theme"
import Navigation from "./navigation"
// import QueryProvider from "./query"
import { QueryClient, QueryClientProvider } from "react-query"
import "react-datepicker/dist/react-datepicker.css"
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

// Create a client
const queryClient = new QueryClient()

function App() {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Navigation />
      </QueryClientProvider>
    </ChakraProvider>
  )
}

export default App
